import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Bar,
  BarChart,
  Brush,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { IChartProps } from '../../../../../component/charts';
import ChartCard from '../../../../../component/charts/chartCard';
import { TransactionedOverExistingRealtiesChartData } from '../types/realtyTransactions.types';

export const TransactionedOverExistingRealties: React.FC = () => {
  const { requestStatusT, chartsDataTransactions } = useSelector(
    (state: any) => state.realtyTransactionsState
  );
  return (
    <ChartCard
      data={chartsDataTransactions['transactioned_over_existing_realties']}
      cy={'TransactionedOverExistingRealties'}
      id={'transactionedOverExistingRealties'}
      Chart={TransactionedOverExistingRealtiesChart}
      requestStatus={requestStatusT['migratoryOrigin']}
      hasAnnualDataOnly
    />
  );
};

const TransactionedOverExistingRealtiesChart: React.FC<
  IChartProps<TransactionedOverExistingRealtiesChartData[]>
> = ({ data, cy, id }) => {
  data = data?.map((el: any) => ({
    ...el,
    transactioned_percent: Number(el.transactioned_percent),
  }));
  const [hasClicked, setHasClicked] = useState<boolean>(false);

  return (
    <ResponsiveContainer data-cy={`transactionedOverExistingRealties${cy}`}>
      <BarChart
        id={id}
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        onClick={() => setHasClicked(!hasClicked)}
      >
        <CartesianGrid strokeDasharray="3 3 3" />
        <Tooltip />
        <XAxis dataKey="id" />
        <YAxis dataKey="" yAxisId="left" orientation="left" stroke="#492273" />
        <Bar
          yAxisId="left"
          isAnimationActive={false}
          name="Transações"
          dataKey="value"
          fill="#492273"
          label={{ position: 'top' }}
        ></Bar>
        <Brush dataKey="id" height={30} stroke="#8884d8" />
      </BarChart>
    </ResponsiveContainer>
  );
};
